// extracted by mini-css-extract-plugin
export default {"hint":"MfaForm_hint__wTrRp","input":"MfaForm_input__VL1-f","button":"MfaForm_button__f5JBl","error":"MfaForm_error__MkbOi"};